/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddressV1Dto } from './AddressV1Dto';
import type { ContactPersonToPartnerV1Dto } from './ContactPersonToPartnerV1Dto';
export type ServiceObjectPartnerV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The name of the partner.
   */
  name: string;
  /**
   * The email address of the partner.
   */
  eMail?: string | null;
  /**
   * The phone number of the partner.
   */
  phone?: string | null;
  /**
   * The language of correspondence with the partner.
   */
  languageOfCorrespondence?: ServiceObjectPartnerV1Dto.languageOfCorrespondence | null;
  /**
   * Addresses associated with the partner
   */
  addresses?: Array<AddressV1Dto> | null;
  /**
   * Contact persons associated with the customer
   */
  contactPersonToPartner?: Array<ContactPersonToPartnerV1Dto> | null;
};
export namespace ServiceObjectPartnerV1Dto {
  /**
   * The language of correspondence with the partner.
   */
  export enum languageOfCorrespondence {
    GERMAN = 'german',
    ENGLISH = 'english',
  }
}
